import { useLocation } from "react-router";
import { Navigate } from "react-router-dom";

// Redirects while preserving query parameters
type Props = {
  to: string;
};

export default function PreserveQueryRedirect({ to }: Props) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return <Navigate to={{ pathname: to, search: params.toString() }} replace />;
}
